export const RaiseEtenral = () => {
    return (
        <div className="container">
            <h2>永続レイズ</h2>
            <p>現在は使えません</p>

        </div>
    )
}